/* ============================================================
   Jack Victor — Collection Horizontal Filters
   File: assets/jv-collection.js

   Wires up filter panels, chip clicks, sort, and form submission.
   All filtering uses Shopify's native URL params — Search & Discovery
   handles the actual product filtering server-side.
   ============================================================ */

(function () {
  'use strict';

  if (window.__jvcCollectionInit) return;
  window.__jvcCollectionInit = true;

  /* ── Panel toggle ── */
  function initPanelToggles() {
    var btns = document.querySelectorAll('.jvc-filter-btn');

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panelId = this.dataset.panel;
        var panel = document.getElementById(panelId);
        var isOpen = this.getAttribute('aria-expanded') === 'true';

        // Close all panels first
        btns.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
        });
        document.querySelectorAll('.jvc-panel').forEach(function (p) {
          p.classList.remove('open');
        });

        // Toggle the clicked one
        if (!isOpen && panel) {
          this.setAttribute('aria-expanded', 'true');
          panel.classList.add('open');
        }
      });
    });

    // Click outside closes panels
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.jvc-strip') && !e.target.closest('.jvc-panels-wrap')) {
        btns.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
        });
        document.querySelectorAll('.jvc-panel').forEach(function (p) {
          p.classList.remove('open');
        });
      }
    });

    // ESC closes panels
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        btns.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
        });
        document.querySelectorAll('.jvc-panel').forEach(function (p) {
          p.classList.remove('open');
        });
      }
    });
  }

  /* ── Chip toggle → form submit ── */
  function initChips() {
    document.querySelectorAll('.jvc-chip').forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        // Don't let the click close the panel (it bubbles to document)
        e.stopPropagation();

        var input = this.querySelector('.jvc-chip-input');
        if (!input) return;

        // Toggle active state and checkbox
        if (input.checked) {
          input.checked = false;
          this.classList.remove('active');
        } else {
          input.checked = true;
          this.classList.add('active');
        }

        // Submit the filter form after a short delay (let the UI update)
        submitFilters();
      });
    });
  }

  /* ── Sort change → navigate ── */
  function initSort() {
    var sortSelect = document.getElementById('jvc-sort');
    if (!sortSelect) return;

    sortSelect.addEventListener('change', function () {
      // Update the sort label text
      var label = this.closest('.jvc-sort-wrap').querySelector('.jvc-sort-label');
      if (label) {
        var selectedText = this.options[this.selectedIndex].text;
        var caret = label.querySelector('.jvc-caret');
        label.textContent = selectedText + ' ';
        if (caret) label.appendChild(caret);
        else {
          var newCaret = document.createElement('span');
          newCaret.className = 'jvc-caret';
          newCaret.setAttribute('aria-hidden', 'true');
          newCaret.textContent = '▾';
          label.appendChild(newCaret);
        }
      }

      submitFilters();
    });
  }

  /* ── Price range submit ── */
  function initPriceRange() {
    var goBtn = document.querySelector('.jvc-price-go');
    if (goBtn) {
      goBtn.addEventListener('click', function (e) {
        e.preventDefault();
        submitFilters();
      });
    }

    // Enter key in price inputs
    document.querySelectorAll('.jvc-price-input').forEach(function (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          submitFilters();
        }
      });
    });
  }

  /* ── Build URL from form state and navigate ── */
  function submitFilters() {
    var form = document.getElementById('jvc-filter-form');
    if (!form) return;

    var formData = new FormData(form);
    var params = new URLSearchParams();

    // Add all checked filter values
    formData.forEach(function (value, name) {
      if (value && value !== '') {
        params.append(name, value);
      }
    });

    // Build the URL
    var baseUrl = window.location.pathname;
    var paramString = params.toString();
    var url = paramString ? baseUrl + '?' + paramString : baseUrl;

    // Navigate (let Shopify handle the filtering)
    window.location.href = url;
  }

  /* ── Init ── */
  function init() {
    initPanelToggles();
    initChips();
    initSort();
    initPriceRange();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
